import { useContext } from 'react'
import { useQueryClient, useQuery } from 'react-query'
import { apiGet, apiPostQuery, estimateQueryStringLength } from 'api'
import AuthContext from 'context/auth-context'

// Puma's default query string limit is 10KB; use POST well before that
const MAX_GET_QUERY_LENGTH = 8000

const getTransactions = async (token, params) => {
  if (estimateQueryStringLength(params) > MAX_GET_QUERY_LENGTH) {
    return apiPostQuery({ url: 'transactions/query', token, params })
  }
  return apiGet({ url: 'transactions', token, params })
}

export default function useTransactions({ params, options }) {
  const token = useContext(AuthContext)
  const queryKey = ['transactions', params]
  const queryFn = () => getTransactions(token, params)

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const getTransaction = async (token, id, params) => {
  const url = `transactions/${id}`

  const data = await apiGet({ url, token, params })
  return data
}

export function useTransaction({ id, params, options }) {
  const token = useContext(AuthContext)
  const queryKey = `transactions/${id}`
  const queryFn = () => getTransaction(token, id, params)

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const getContractAccounts = async (token, id) => {
  const url = `transactions/${id}/contract_accounts`
  const data = await apiGet({ url, token })
  return data
}

export function useContractAccounts({ id, options }) {
  const token = useContext(AuthContext)
  const queryKey = ['contract-accounts', id]
  const queryFn = () => getContractAccounts(token, id)

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

export function usePrefetchTransaction({ id }) {
  const queryClient = useQueryClient()
  const token = useContext(AuthContext)
  const queryKey = `transactions/${id}`
  const params = {}

  if (typeof id === 'string' && id.length > 0) {
    queryClient.prefetchQuery(
      queryKey,
      () => getTransaction(token, id, params),
      {
        staleTime: 30000
      }
    )
  }
}
